// extracted by mini-css-extract-plugin
export default {"teamPresentation":"styles_teams_teamPresentation__9pBYF"};